import { render, staticRenderFns } from "./shopmemberoder.vue?vue&type=template&id=48a63779&scoped=true&"
import script from "./shopmemberoder.vue?vue&type=script&lang=js&"
export * from "./shopmemberoder.vue?vue&type=script&lang=js&"
import style0 from "./shopmemberoder.vue?vue&type=style&index=0&id=48a63779&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a63779",
  null
  
)

export default component.exports